module.exports = __webpack_public_path__ + "static/media/10_insideyourblood.1209a354.jpg";